const FETCH_LEAD_INFO = 'leads/infolead/FETCH_LEAD_INFO';
const FETCH_LEAD_INFO_SUCCEEDED = 'leads/infolead/FETCH_LEAD_INFO_SUCCEEDED';
const FETCH_LEAD_INFO_FAILED = 'leads/infolead/FETCH_LEAD_INFO_FAILED';

const FETCH_EMAIL_VALIDATION_SUCCEEDED = 'leads/infolead/FETCH_EMAIL_VALIDATION_SUCCEEDED';
const FETCH_EMAIL_VALIDATION_NO_DATA = 'leads/infolead/FETCH_EMAIL_VALIDATION_NO_DATA';
const FETCH_PHONE_VALIDATION_SUCCEEDED = 'leads/infolead/FETCH_PHONE_VALIDATION_SUCCEEDED';
const FETCH_PHONE_VALIDATION_RESET = 'leads/infolead/FETCH_PHONE_VALIDATION_SUCCEEDED';

const FETCH_SEND_EMAIL = 'leads/infolead/FETCH_SEND_EMAIL';
const FETCH_SEND_EMAIL_SUCCESS = 'leads/infolead/FETCH_SEND_EMAIL_SUCCESS';
const FETCH_SEND_EMAIL_ERROR = 'leads/infolead/FETCH_SEND_EMAIL_ERROR';

const UPDATE_LEAD_STATUS = 'leads/infolead/UPDATE_LEAD_STATUS';
const UPDATE_LEAD_STATUS_SUCCEEDED = 'leads/infolead/UPDATE_LEAD_STATUS_SUCCEEDED';
const UPDATE_LEAD_STATUS_FAILED = 'leads/infolead/UPDATE_LEAD_STATUS_FAILED';

const FETCH_SCORELEAD = 'leads/infolead/FETCH_SCORELEAD';
const FETCH_SCORELEAD_SUCCEEDED = 'leads/infolead/FETCH_SCORELEAD_SUCCEEDED';
const FETCH_SCORELEAD_FAILED = 'leads/infolead/FETCH_SCORELEAD_FAILED';
const FETCH_SCORELEAD_NOPOSTING = 'leads/infolead/FETCH_SCORELEAD_NOPOSTING';

const FETCH_RENTERPROFILE = 'leads/infolead/FETCH_RENTERPROFILE';
const FETCH_RENTERPROFILE_SUCCEEDED = 'leads/infolead/FETCH_RENTERPROFILE_SUCCEEDED';
const FETCH_RENTERPROFILE_FAILED = 'leads/infolead/FETCH_RENTERPROFILE_FAILED';
const FETCH_RENTERPROFILE_NOPOSTING = 'leads/infolead/FETCH_RENTERPROFILE_NOPOSTING';
const FETCH_RENTERPROFILE_RESET = 'leads/infolead/FETCH_RENTERPROFILE_RESET';

const FETCH_CUSTOM_ANSWERS = 'leads/infolead/FETCH_CUSTOM_ANSWERS';
const FETCH_CUSTOM_ANSWER_STATUS = 'leads/infolead/FETCH_CUSTOM_ANSWER_STATUS';
const FETCH_CUSTOM_ANSWER_RESET = 'leads/infolead/FETCH_CUSTOM_ANSWER_RESET';

const FETCH_SMARTLEAD = 'leads/infolead/FETCH_SMARTLEAD';
const FETCH_SMARTLEAD_SUCCEEDED = 'leads/infolead/FETCH_SMARTLEAD_SUCCEEDED';
const FETCH_SMARTLEAD_FAILED = 'leads/infolead/FETCH_SMARTLEAD_FAILED';
const FETCH_SMARTLEAD_RESET = 'leads/infolead/FETCH_SMARTLEAD_RESET';

const FETCH_RELATED = 'leads/infolead/FETCH_RELATED';
const FETCH_RELATED_SUCCEEDED = 'leads/infolead/FETCH_RELATED_SUCCEEDED';
const FETCH_RELATED_FAILED = 'leads/infolead/FETCH_RELATED_FAILED';

const SHOW_SNACKBAR = 'leads/infolead/SHOW_SNACKBAR';
const HIDE_SNACKBAR = 'leads/infolead/HIDE_SNACKBAR';

const SHOW_SNACKBAR_LEAD_DETAIL = 'leads/infolead/SHOW_SNACKBAR_LEAD_DETAIL';
const HIDE_SNACKBAR_LEAD_DETAIL = 'leads/infolead/HIDE_SNACKBAR_LEAD_DETAIL';

const FETCH_MESSAGEATTACHEMENTS = 'leads/infolead/FETCH_MESSAGEATTACHEMENTS';
const FETCH_MESSAGEATTACHEMENTS_SUCCEEDED = 'leads/infolead/FETCH_MESSAGEATTACHEMENTS_SUCCEEDED';
const FETCH_MESSAGEATTACHEMENTS_FAILED = 'leads/infolead/FETCH_MESSAGEATTACHEMENTS_FAILED';
const SELECTED_PHONE = 'leads/infolead/SELECTED_PHONE';
const FETCH_FEEDBACK_RESET = 'leads/infolead/FETCH_FEEDBACK_RESET';

const FETCH_LEADS_ETIQUETAS = 'leads/infolead/FETCH_LEADS_ETIQUETAS';
const FETCH_LEADS_ETIQUETAS_SUCCEEDED = 'leads/infolead/FETCH_LEADS_ETIQUETAS_SUCCEEDED';
const FETCH_LEADS_ETIQUETAS_CHANGUE = 'leads/infolead/FETCH_LEADS_ETIQUETAS_CHANGUE';

export {
  HIDE_SNACKBAR_LEAD_DETAIL,
  SHOW_SNACKBAR_LEAD_DETAIL,
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
  FETCH_EMAIL_VALIDATION_SUCCEEDED,
  FETCH_EMAIL_VALIDATION_NO_DATA,
  FETCH_PHONE_VALIDATION_SUCCEEDED,
  FETCH_LEAD_INFO,
  FETCH_LEAD_INFO_SUCCEEDED,
  FETCH_LEAD_INFO_FAILED,
  UPDATE_LEAD_STATUS,
  UPDATE_LEAD_STATUS_SUCCEEDED,
  UPDATE_LEAD_STATUS_FAILED,
  FETCH_SMARTLEAD,
  FETCH_SMARTLEAD_SUCCEEDED,
  FETCH_SMARTLEAD_FAILED,
  FETCH_SMARTLEAD_RESET,
  FETCH_SCORELEAD,
  FETCH_SCORELEAD_SUCCEEDED,
  FETCH_SCORELEAD_FAILED,
  FETCH_SCORELEAD_NOPOSTING,
  FETCH_RENTERPROFILE,
  FETCH_RENTERPROFILE_SUCCEEDED,
  FETCH_RENTERPROFILE_FAILED,
  FETCH_RENTERPROFILE_NOPOSTING,
  FETCH_RENTERPROFILE_RESET,
  FETCH_RELATED,
  FETCH_RELATED_SUCCEEDED,
  FETCH_RELATED_FAILED,
  FETCH_CUSTOM_ANSWERS,
  FETCH_CUSTOM_ANSWER_STATUS,
  FETCH_CUSTOM_ANSWER_RESET,
  FETCH_PHONE_VALIDATION_RESET,
  FETCH_MESSAGEATTACHEMENTS,
  FETCH_MESSAGEATTACHEMENTS_SUCCEEDED,
  FETCH_MESSAGEATTACHEMENTS_FAILED,
  SELECTED_PHONE,
  FETCH_FEEDBACK_RESET,
  FETCH_LEADS_ETIQUETAS,
  FETCH_LEADS_ETIQUETAS_SUCCEEDED,
  FETCH_SEND_EMAIL,
  FETCH_SEND_EMAIL_SUCCESS,
  FETCH_SEND_EMAIL_ERROR,
  FETCH_LEADS_ETIQUETAS_CHANGUE
};
